import { PageInfoServiceV1 } from '@volkswagen-onehub/page-info-service';
import { useEffect } from 'react';
import * as React from 'react';
import { Helmet } from 'react-helmet-async';

export function HelmetUpdater(props: {
  pageInfoService: PageInfoServiceV1;
}): JSX.Element {
  const { pageInfoService } = props;
  const [pageInfo, setPageInfo] = React.useState(pageInfoService.getPageInfo());

  useEffect(() => {
    const currentPageInfo = pageInfoService.getPageInfo();

    setPageInfo(currentPageInfo);

    const unsubscribe = pageInfoService.subscribe(() => {
      const updatedPageInfo = pageInfoService.getPageInfo();
      setPageInfo(updatedPageInfo);
    });

    return () => {
      unsubscribe();
    };
  }, [pageInfoService]);

  const seo = pageInfo.seo;
  if (!seo) {
    return React.createElement(Helmet, {}, null);
  }

  return React.createElement(
    Helmet,
    {},
    <>
      {seo.pageTitle && <title>{seo.pageTitle}</title>}
      {seo.description && <meta name='description' content={seo.description} />}
      {seo.og?.ogTitle && <meta property='og:title' content={seo.og.ogTitle} />}
      {seo.og?.ogDescription && (
        <meta property='og:description' content={seo.og.ogDescription} />
      )}
      {seo.og?.ogType && <meta property='og:type' content={seo.og.ogType} />}
      {seo.og?.ogImage && <meta property='og:image' content={seo.og.ogImage} />}
      {seo.og?.ogUrl && <meta property='og:url' content={seo.og.ogUrl} />}
      {seo.twitter?.twitterTitle && (
        <meta name='twitter:title' content={seo.twitter.twitterTitle} />
      )}
      {seo.twitter?.twitterDescription && (
        <meta
          name='twitter:description'
          content={seo.twitter.twitterDescription}
        />
      )}
      {seo.twitter?.twitterImage && (
        <meta name='twitter:image' content={seo.twitter.twitterImage} />
      )}
      {seo.twitter?.twitterCard && (
        <meta name='twitter:card' content={seo.twitter.twitterCard} />
      )}
      {seo.canonicalUrl && <link rel='canonical' href={seo.canonicalUrl} />}
      {seo.keywords && <meta name='keywords' content={seo.keywords} />}
      {/* AEM CMS metadata tags - using pageTitle for VW.gsaTitle and VW:gsaTitle */}
      {seo.pageTitle && (
        <>
          <meta property='VW.gsaTitle' content={seo.pageTitle} />
          <meta property='VW:gsaTitle' content={seo.pageTitle} />
        </>
      )}
    </>
  );
}
